module.exports = __webpack_public_path__ + "static/media/ic-info.ba88c2b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-info.svg
// module id = 630
// module chunks = 14